module.exports = __webpack_public_path__ + "img/card6-bl4.743d2e3b.svg";